module.exports = __webpack_public_path__ + "img/badge_concerti.3865494a.jpg";